<app-collapsible-card [cardTitle]="sportName">
    <div *ngFor="let category of categories">
        <div class="card-body p-0">
            <ul class="list-group list-group-flush">
                <li class="list-group-item bg-light">
                    <p><b>{{category.name}}</b></p>
                </li>
                <li *ngFor="let document of category.documents" class="list-group-item">
                    <div (click)="openDocument(document)" role="button" class="d-flex gap-1 text-primary">
                        <span class="position-relative">
                            <span *ngIf="document.type == documentLinkTypeEnum.Link">
                                <i class="fa-solid fa-link"></i>
                            </span>
                            <span *ngIf="document.type == documentLinkTypeEnum.Document" class="px-1">
                                <i class="fa-solid fa-file"></i>
                            </span>
                            <span
                                class="activ-filter-status-indicator position-absolute top-0 start-50 p-1 ms-1 rounded-circle "
                                *ngIf="document.acceptanceDeadlineUtc != null && !document.isReadByUser">
                            </span>
                        </span>
                        <span>{{document.name}}</span>
                    </div>
                    <div *ngIf="document.description != null" [innerHTML]=" document.description"
                        style="white-space: pre-line;">
                    </div>
                </li>
            </ul>
        </div>
    </div>
</app-collapsible-card>